import React, { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { degrageUserToBasic } from "./action";

function DowngradeUser({ user, getUsers }) {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const handleClick = () => {
    setIsLoading(true);
    dispatch(degrageUserToBasic(user.id, getUsers, setIsLoading));
  };
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {user?.subscription_type && user?.subscription_type !== "BASIC" && (
        <Button type="button" className="btn-primary  w-100" onClick={handleClick} disabled={isLoading}>
          Downgrade to Basic {isLoading ? <Spinner animation="border" size="sm" /> : null}
        </Button>
      )}
    </>
  );
}

export default DowngradeUser;
